import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";

const ModalLayout = ({
  show,
  modalBody = "<div></div>",
  modalFooter = "<div></div>",
  title,
  setShow,
}) => {
  const handleClose = () => setShow(false);
  return (
    <Modal
      show={show}
      onHide={handleClose}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{modalBody}</Modal.Body>
      <Modal.Footer>{modalFooter}</Modal.Footer>
    </Modal>
  );
};

ModalLayout.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  modalBody: PropTypes.node,
  modalFooter: PropTypes.node,
  title: PropTypes.string.isRequired,
};

export default ModalLayout;
